"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useGeolocation = (options, enabled = true) => {
    const [isEnabled, setIsEnabled] = react_1.default.useState(enabled);
    const [state, setState] = react_1.default.useState({
        isEnabled,
        setIsEnabled,
        isLoading: true,
        accuracy: null,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        latitude: null,
        longitude: null,
        speed: null,
        timestamp: Date.now(),
    });
    const isMounted = react_1.default.useRef(false);
    const watchId = react_1.default.useRef();
    const handleEvent = (event) => {
        if (isMounted.current) {
            setState((s) => ({
                isEnabled: s.isEnabled,
                setIsEnabled: s.setIsEnabled,
                isLoading: false,
                accuracy: event.coords.accuracy,
                altitude: event.coords.altitude,
                altitudeAccuracy: event.coords.altitudeAccuracy,
                heading: event.coords.heading,
                latitude: event.coords.latitude,
                longitude: event.coords.longitude,
                speed: event.coords.speed,
                timestamp: event.timestamp,
            }));
        }
    };
    const handleLocationError = (error) => {
        // eslint-disable-next-line no-unused-expressions
        isMounted.current && setState((oldState) => (Object.assign(Object.assign({}, oldState), { isLoading: false, error })));
    };
    const handlePermission = () => {
        if (watchId === null || watchId === void 0 ? void 0 : watchId.current) {
            navigator.geolocation.clearWatch(watchId.current);
        }
        navigator.geolocation.getCurrentPosition(handleEvent, handleLocationError, options);
        watchId.current = navigator.geolocation.watchPosition(handleEvent, handleLocationError, options);
    };
    const handlePermissionChange = (event) => {
        // eslint-disable-next-line no-param-reassign
        event.onchange = handlePermission;
    };
    react_1.default.useEffect(() => {
        setState((s) => (Object.assign(Object.assign({}, s), { isEnabled })));
        if (!isEnabled)
            return undefined;
        isMounted.current = true;
        /**
         * Supported on Edge, Chrome, Firefox Opera
         * Safari will automatically fire handleEvent callback when settings changes
         */
        if (navigator.permissions) {
            navigator.permissions.query({ name: 'geolocation' }).then(handlePermissionChange);
        }
        navigator.geolocation.getCurrentPosition(handleEvent, handleLocationError, options);
        watchId.current = navigator.geolocation.watchPosition(handleEvent, handleLocationError, options);
        return () => {
            isMounted.current = false;
            if (watchId === null || watchId === void 0 ? void 0 : watchId.current) {
                navigator.geolocation.clearWatch(watchId.current);
            }
        };
    }, [isEnabled]);
    return state;
};
exports.default = useGeolocation;
